import MarqueeLib from "react-fast-marquee";
import { Zap, ShieldCheck, Gauge, Infinity as InfinityIcon, Globe, Music } from "lucide-react";
import { useLang } from "@/context/LangContext";

const icons = [ShieldCheck, Gauge, Zap, InfinityIcon, Globe, Music];

export default function Marquee() {
  const { t } = useLang();
  const texts = t("marquee");
  return (
    <div className="border-y border-white/10 bg-surface/40 py-6 overflow-hidden" data-testid="features-marquee">
      <MarqueeLib speed={32} gradient={false} direction="left" pauseOnHover>
        {texts.map((text, i) => {
          const Icon = icons[i % icons.length];
          return (
            <span key={i} className="mx-10 flex items-center gap-3 text-ice/70">
              <Icon className="h-5 w-5 text-neon" />
              <span className="font-display text-xl tracking-wide">{text}</span>
              <span className="ms-10 h-1.5 w-1.5 rounded-full bg-webcyan/60" />
            </span>
          );
        })}
      </MarqueeLib>
    </div>
  );
}
